// Vite exécute ce fichier, qui appelle tous les autres

console.log("Vite ⚡️ Rails");

// Example: Load Rails libraries in Vite.
//
// import * as Turbo from '@hotwired/turbo'
// Turbo.start()
//
// import ActiveStorage from '@rails/activestorage'
// ActiveStorage.start()
//
// // Import all channels.
// const channels = import.meta.globEager('./**/*_channel.js')

// Example: Import a stylesheet in app/frontend/index.css
// import '~/index.css'
//

import "@hotwired/turbo-rails";
import { Application } from "@hotwired/stimulus";
import { registerControllers } from "stimulus-vite-helpers";
// Stimulus controllers
import PasswordVisibility from "stimulus-password-visibility";
import Popover from "stimulus-popover";
import Reveal from "stimulus-reveal-controller";
import Sortable from "stimulus-sortable";
// Alpine
import Alpine from "alpinejs";
// Shepherd
import Cookies from "js-cookie";
// Turbo
import * as Turbo from "@hotwired/turbo";
// Turbo Mount
import "../turbo-mount";
// Action custom turbo stream
import "../turbo_streams/open_next_unanswered"
import "../turbo_streams/reload_frame"
import "../turbo_streams/composition_document_imported"
import "../turbo_streams/composition_shot_settled"
import "../lib/frame_transitions"
import "../lib/frame_hosts"
// Apilink theme editor (extracted from inline scripts)
import "../lib/apilink_theme_editor"
Turbo.start();

Turbo.config.forms.confirm = (message, form) => {
  const confirmed = window.confirm(message);
  if (!confirmed && form.dataset.resetOnCancel) {
    form.reset();
  }
  return confirmed;
};

window.Cookies = Cookies;




const application = Application.start();
// ATTENTION : ce glob embarque TOUT le dossier controllers/ dans le bundle de
// production, en eager. Un fichier de test posé là importerait `vitest`, absent
// du navigateur : l'import casse, application.js ne démarre pas, et TOUTE l'app
// devient une page blanche — sans erreur au build. Vécu le 2026-08-13 (#4027).
// Les exclusions ci-dessous sont un garde-fou, pas une préférence de style.
const controllers = import.meta.glob(
  [
    "./../controllers/**/*.ts",
    "./../controllers/**/*.js",
    "./../controllers/**/*.tsx",
    "./../controllers/**/*.jsx",
    "!./../controllers/**/*.test.*",
    "!./../controllers/**/*.spec.*",
  ],
  { eager: true }
);

registerControllers(application, controllers);
application.register("sortable", Sortable);
application.register("password-visibility", PasswordVisibility);
application.register("popover", Popover);
application.register("reveal", Reveal);

window.Alpine = Alpine;
Alpine.start();

// On force la fermeture des notifications entre les changements de pages
document.addEventListener("turbo:before-visit", () => {
  const flashContainer = document.getElementById("notification");
  console.log("flashContainer", flashContainer);
  if (flashContainer) {
    flashContainer.innerHTML = "";
  }
});

function setupModals() {
  const cgu_modal = document.querySelector("#cgu_modal");
  const stepper_modal = document.querySelector("#stepper_modal");
  if (cgu_modal) return window.openDialog("cgu_modal");
  if (stepper_modal) return window.openDialog("stepper_modal");
}

document.addEventListener("turbo:load", setupModals);
